// USP grade scale used by TargetCalculator
// Each entry defines the minimum total percentage required for that grade
export const USP_GRADE_SCALE = [
  { grade: 'A+', minPercent: 85, gpa: 4.5 },
  { grade: 'A',  minPercent: 80, gpa: 4.0 },
  { grade: 'B+', minPercent: 75, gpa: 3.5 },
  { grade: 'B',  minPercent: 70, gpa: 3.0 },
  { grade: 'C+', minPercent: 65, gpa: 2.5 },
  { grade: 'C',  minPercent: 50, gpa: 2.0 },
  { grade: 'R',  minPercent: 45, gpa: 1.5 },
  { grade: 'D',  minPercent: 40, gpa: 1.0 },
  { grade: 'E',  minPercent: 0,  gpa: 0.0 }
];

const constants = {
  USP_GRADE_SCALE
};

export default constants;
